import { defaultHttpClient } from '../../httpClient';
import type { GoodsPiecesResponse } from './types';

/**
 * - 상품 치수 정보 조회 API
 * - GET /api/v2/goods/{sno}/pieces/
 */
export const getGoodsPieces = (goodsSno: number) => {
  return defaultHttpClient
    .request<GoodsPiecesResponse>({
      method: 'GET',
      url: `/api/v2/goods/${goodsSno}/pieces/`,
    })
    .then(result => result.data);
};